webpackJsonp([144251824217401],{

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Card = __webpack_require__(41);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _CardText = __webpack_require__(29);
	
	var _CardText2 = _interopRequireDefault(_CardText);
	
	var _UserLinks = __webpack_require__(43);
	
	var _UserLinks2 = _interopRequireDefault(_UserLinks);
	
	var _SiteConfig = __webpack_require__(15);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	__webpack_require__(547);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var About = function (_Component) {
	  _inherits(About, _Component);
	
	  function About() {
	    _classCallCheck(this, About);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  About.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "about-container md-grid mobile-fix" },
	      _react2.default.createElement(
	        _Card2.default,
	        { className: "md-grid md-cell--8" },
	        _react2.default.createElement(
	          "div",
	          { className: "about-wrapper" },
	          _react2.default.createElement("img", {
	            src: _SiteConfig2.default.userAvatar,
	            className: "about-img",
	            alt: _SiteConfig2.default.userName
	          }),
	          _react2.default.createElement(
	            _CardText2.default,
	            null,
	            _react2.default.createElement(
	              "p",
	              { className: "about-text md-body-1" },
	              _SiteConfig2.default.userDescription
	            )
	          ),
	          _react2.default.createElement(_UserLinks2.default, { labeled: true, config: _SiteConfig2.default })
	        )
	      )
	    );
	  };
	
	  return About;
	}(_react.Component);
	
	exports.default = About;
	module.exports = exports["default"];

/***/ }),

/***/ 547:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Buttons = __webpack_require__(40);
	
	var _Buttons2 = _interopRequireDefault(_Buttons);
	
	__webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserLinks = function (_Component) {
	  _inherits(UserLinks, _Component);
	
	  function UserLinks() {
	    _classCallCheck(this, UserLinks);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  UserLinks.prototype.getLinkElements = function getLinkElements() {
	    var userLinks = this.props.config.userLinks;
	    var labeled = this.props.labeled;
	
	    return userLinks.map(function (link) {
	      return _react2.default.createElement(
	        _Buttons2.default,
	        {
	          icon: !labeled,
	          flat: labeled,
	          secondary: true,
	          key: link.label,
	          iconClassName: link.iconClassName,
	          href: link.url
	        },
	        labeled ? link.label : ""
	      );
	    });
	  };
	
	  UserLinks.prototype.render = function render() {
	    var userLinks = this.props.config.userLinks;
	
	    if (!userLinks) {
	      return null;
	    }
	    return _react2.default.createElement(
	      "div",
	      { className: "user-links" },
	      this.getLinkElements()
	    );
	  };
	
	  return UserLinks;
	}(_react.Component);
	
	exports.default = UserLinks;
	module.exports = exports["default"];

/***/ }),

/***/ 72:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(28);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _About = __webpack_require__(290);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _SiteConfig = __webpack_require__(15);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AboutPage = function (_Component) {
	  _inherits(AboutPage, _Component);
	
	  function AboutPage() {
	    _classCallCheck(this, AboutPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  AboutPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "about-container" },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          "title",
	          null,
	          "About | " + _SiteConfig2.default.siteTitle
	        ),
	        _react2.default.createElement("link", { rel: "canonical", href: _SiteConfig2.default.siteUrl + "/about/" })
	      ),
	      _react2.default.createElement(_About2.default, null)
	    );
	  };
	
	  return AboutPage;
	}(_react.Component);
	
	exports.default = AboutPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-jsx-ad03a97f9d94d9bb3877.js